import { stringify, parse } from 'flatted';
export var storageService = {
    get: function (key, useLocalStorage) {
        var value = (useLocalStorage ? localStorage : sessionStorage).getItem(key);
        if (!value)
            return null;
        try {
            return parse(value);
        }
        catch (e) {
            console.log("storage service get: ", e);
            return null;
            //return value;
        }
    },
    set: function (key, value, useLocalStorage) {
        (useLocalStorage ? localStorage : sessionStorage).setItem(key, stringify(value));
    },
    remove: function (key, useLocalStorage) {
        (useLocalStorage ? localStorage : sessionStorage).removeItem(key);
    },
};
